/* eslint-disable */
import ProgressTracker from '@/views/probaworkflows_base/management/trust_applications/progress_tracker/ProgressTracker.vue';
import ApplicationVerification from '@/views/probaworkflows_base/management/trust_applications/application_verification/ApplicationVerification.vue';
import InvoiceOverview from '@/views/probaworkflows_base/invoicing/invoice_overview/InvoiceOverview.vue';
import VerificationOverview from '@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_overview/VerificationOverview.vue';
import ApplicationContracts from '@/views/probaworkflows_base/management/trust_applications/application_contracts/ApplicationContracts.vue';
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';
import ViewComplianceChecks from '@/views/probaworkflows_base/management/compliance_management/view_compliance_checks/ViewComplianceChecks.vue';
 
export default {
  name: 'MasterOfficeSubmissions',
  components: {
    ProgressTracker,
    ApplicationVerification,
    InvoiceOverview,
    VerificationOverview,
    ApplicationContracts,
    NavigationBackButton,
    ViewComplianceChecks
  },
  data: () => ({
    founder_name: "",
    profile_role_form_id: null,
    form_id: null,
    role_id: null,
    user_id: null,
    profile_role_id: null,
    activeTab: null,
    selectedDropdown: null,
    loadingMoreTabs: false,
    entity_id:'',
    allTabs: [
    { id: 'trust_information', name: 'Trust Information', hasDropdown: true },
    { id: 'main_contact_details', name: 'Main Contact Details', hasDropdown: true },
    { id: 'founders_details', name: 'Founders Details', hasDropdown: true },
    { id: 'trustees', name: 'Trustees', hasDropdown: true },
    { id: 'beneficiary_information', name: 'Beneficiary Information', hasDropdown: true },
    { id: 'auditors_information', name: 'Auditors Information', hasDropdown: true },
    { id: 'bond_security', name: 'Bond Security', hasDropdown: true },
    { id: 'supporting_documents', name: 'Supporting Documents', hasDropdown: true },

    ],
    visibleTabs: [], // Tabs currently visible in the UI
    dropdownOptions: {
      trust_information: [{ value: 'trust information', label: 'Trust information' }],
      main_contact_details: [{ value: 'main contact details', label: 'Main contact details' }],
      founders_details: [{ value: 'founders details', label: 'Founders details' }],
      trustees: [{ value: 'trustees', label: 'Trustees' }],
      beneficiary_information: [{ value: 'beneficiary information', label: 'Beneficiary information' }],
      auditors_information: [{ value: 'auditors information', label: 'Auditors information' }],
      bond_security: [{ value: 'bond security', label: 'Bond security' }],
      supporting_documents: [{ value: 'supporting documents', label: 'Supporting documents' }],
    }
  }),
  computed: {
    activeTabHasDropdown() {
      const tab = this.visibleTabs.find(t => t.id === this.activeTab);
      return tab?.hasDropdown || false;
    },
    activeTabDropdownOptions() {
      return this.dropdownOptions[this.activeTab] || [];
    },
    activeTabDetails() {
      return this.visibleTabs.find(tab => tab.id === this.activeTab) || {};
    },
  },
  methods: {
    initializeTabs() {
      this.visibleTabs = [...this.allTabs];
      if (this.visibleTabs.length > 0) {
        this.selectTab(this.visibleTabs[0].id);
      }
    },
    selectTab(tabId) {
      this.activeTab = tabId;
      const options = this.dropdownOptions[tabId];
      if (this.activeTabHasDropdown && options?.length > 0) {
        this.selectedDropdown = options[0].value;
      } else {
        this.selectedDropdown = null;
      }
    },
    toggleDropdown(value) {
      this.selectedDropdown = this.selectedDropdown === value ? '' : value;
    },
    
  },
  created(){
    this.profile_role_form_id = this.$route.query.profile_role_form_id || null;
    this.form_id = this.$route.query.form_id || null;
    this.founder_name = this.$route.query.founder_name || "";
    this.role_id = this.$route.query.role_id || null;
    this.profile_role_id = this.$route.query.profile_role_id || null;
    this.user_id = this.$route.query.user_id || null;

  },
  mounted() {
    this.entity_id = this.$route.query.entity_id;
    this.initializeTabs();
  }
};
 